import { useMemo } from "react";

const IGNORE = "[data-no-swipe],input,textarea,select,[draggable='true'],[role='dialog']";

/** Left / right swipe on phones and small tablets — ignores drags, scrollers and form fields. */
export const useSwipe = (onLeft, onRight, options = {}) => {
  const { minDistance = 60, maxOffAxis = 45, maxWidth = 900 } = options;

  return useMemo(() => {
    let start = null;
    return {
      onTouchStart: (e) => {
        start = null;
        if (typeof window !== "undefined" && window.innerWidth > maxWidth) return;
        if (e.target?.closest?.(IGNORE)) return;
        const touch = e.touches?.[0];
        if (touch) start = { x: touch.clientX, y: touch.clientY };
      },
      onTouchEnd: (e) => {
        if (!start) return;
        const touch = e.changedTouches?.[0];
        const dx = (touch?.clientX ?? start.x) - start.x;
        const dy = (touch?.clientY ?? start.y) - start.y;
        start = null;
        if (Math.abs(dy) > maxOffAxis || Math.abs(dx) < minDistance) return;
        (dx < 0 ? onLeft : onRight)?.();
      },
    };
  }, [onLeft, onRight, minDistance, maxOffAxis, maxWidth]);
};
